var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"history"},[_c('TabTitle',{attrs:{"title":"代下素材"}}),_c('div',{staticClass:"table-container"},[_c('Table',{attrs:{"obj":_vm.tabList[0].data},on:{"sizeChange":_vm.sizeChange,"pageChange":_vm.pageChange}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }